import { useParams } from 'react-router';
import { SimDetails } from '../../common/components/Sim/Details/SimDetails';

import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { Routes } from 'src/Routes.constants';
import { RefetchQueryButton } from 'src/common/components/Queries/RefetchQueryButton';
import { ScrollArea } from 'src/common/components/ScrollArea/ScrollArea';
import { useSimDetails } from '../hooks/useSimDetails';
import { detailsQueries } from 'src/common/components/Sim/Details/queries/detailsQueries';
import { enrichWithSessionDetailsMapper, useSessionsDetails } from '../hooks/useSessionsDetails';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';

const SimInventoryDetailsPageRoot = styled('div')({
  padding: '8px 0',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
});

export type SimInventoryEntryRoutingParams = {
  iccid: string;
};

export const SimProfileDetails = () => {
  const { iccid } = useParams<SimInventoryEntryRoutingParams>();
  if (!iccid) {
    throw new Error('No iccid');
  }

  const { data } = useSimDetails(iccid);

  const { data: sessionsDetails, isFetching: isSessionDetailsLoading } = useSessionsDetails({
    imsis: data?.imsi ? [data.imsi] : [],
    queryKey: detailsQueries.sessionDetails(data?.imsi),
  });

  if (data === null) {
    throw new Error('No data for iccid');
  }
  const isRadiusInterimsFilteringEnabled = useHasFeatureFlag('RadiusInterimsFiltering');
  const enrichedData = isRadiusInterimsFilteringEnabled
    ? enrichWithSessionDetailsMapper(data, sessionsDetails)
    : data;

  return (
    <SimInventoryDetailsPageRoot>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          pt: 8,
          pr: 24,
        }}
      >
        <RefetchQueryButton queryKey={detailsQueries.details} />
      </Box>
      <ScrollArea className="os-host-flexbox">
        <SimDetails
          data={enrichedData}
          baseRoute={Routes.simInventory}
          isSessionDetailsLoading={isSessionDetailsLoading}
        />
      </ScrollArea>
    </SimInventoryDetailsPageRoot>
  );
};
